export default data =>
    Object.entries(data)
        .sort(([, labelA], [, labelB]) => labelA.localeCompare(labelB))
        .map(([value, label]) => ({ label, value }));
